import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";

import { ReactComponent as FileIcon } from "../../../assets/Icons/file-text.svg";
import Filter from "./Filter";
import CheckBox from "../../../components/CheckBox";
import { useSpecialties } from "../../../contexts/specialties";

const SpecialtiesFilter = ({
  filters,
  setFilters,
  value,
  isMobileView,
  goBack,
  reset,
}) => {
  const { fetchSpecialties, specialties } = useSpecialties();
  const [expanded, setExpanded] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchSpecialties();
    if (goBack && reset) {
      setExpanded(true);
      setSearch("");
    }
  }, []);

  const handleSearch = (ev) => {
    setSearch(ev.target.value);
  };

  const toggleExpand = () => {
    setExpanded((prevState) => !prevState);
  };

  const handleChange = (ev) => {
    setFilters((prevState) => {
      const arr = prevState.specialties || [];
      const exists = Boolean(arr.find((item) => item === ev.target.value));
      return {
        ...prevState,
        specialties: exists
          ? arr.filter((item) => item !== ev.target.value)
          : [...arr, ev.target.value],
      };
    });
    setSearch("");
  };

  return (
    <Filter
      label="Specialities"
      icon={<FileIcon />}
      isRigntIcon={true}
      goBack={goBack}
      reset={reset}
    >
      <FormControlLabel
        control={
          <Switch
            checked={filters?.must_have_specialities}
            onChange={() =>
              setFilters((filters) => ({
                ...filters,
                must_have_specialities: filters?.must_have_specialities
                  ? undefined
                  : 1,
              }))
            }
          />
        }
        label={"Must Have"}
        sx={{ mb: 1 }}
      />
      <TextField
        fullWidth
        placeholder="Search"
        sx={{
          "input:not(textarea)": {
            pt: { xs: 1.75, sm: 1.5 },
            pb: 1.5,
            fontSize: { xs: 12, sm: 14 },
            px: 1,
            "&::placeholder": {
              fontWeight: 700,
            },
            height: isMobileView ? "40px" : "25px",
            mb: isMobileView ? 1 : 0,
          },
        }}
        name="search"
        onChange={handleSearch}
        value={search}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          maxHeight: expanded ? "none" : 90,
          overflow: "hidden",
          pt: isMobileView ? 2 : 0,
        }}
      >
        {specialties.list.reduce((acc, item) => {
          const isChecked = Boolean(
            value.find((data) => data.toString() === item.id.toString())
          );
          if (search && !item.name.toLowerCase().includes(search.toLowerCase()))
            return acc;

          if (isChecked) {
            return [
              <CheckBox
                key={item.id}
                label={item.name}
                value={item.id}
                onChange={handleChange}
                checked={true}
              />,
              ...acc,
            ];
          }
          return [
            ...acc,
            <CheckBox
              key={item.id}
              label={item.name}
              value={item.id}
              onChange={handleChange}
              checked={false}
            />,
          ];
        }, [])}
      </Box>

      <Button
        sx={{
          p: 0,
          justifyContent: "flex-start",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
        onClick={toggleExpand}
        disableRipple
      >
        {expanded ? "See less" : "See more"}
      </Button>
    </Filter>
  );
};

export default SpecialtiesFilter;
